"use strict";

(function ($) {
  /*--------------------------------------------------*/
  var Common= {
		init: function() {

			this.view = {};
			this.view.window = $(window);
      var test = [];
			this.view.dir = $("#info").data('dir');
      this.initShow();
      this.csvGet("/hogosha/_news/" + this.view.dir +"/news1.txt" ,1);
      this.csvGet("/hogosha/_news/" + this.view.dir +"/news2.txt" ,2);
      // console.log(this.view.dir);
    },
    initShow:function(){
      var getNum = $("#Topinfo").data("num");
      var topListNum = getNum ? getNum+1 : 5;
      var initHide = getNum ? getNum : 4 ;

      //指定の要素の次以降を非表示
      $("#Topinfo li").eq(initHide).nextAll().hide();

      console.log($("#Topinfo li").length,topListNum,getNum);

      if( $("#Topinfo li").length <= topListNum){
          $(".info__moreBtn").hide();
      }else{
        $(".info__moreBtn").on("click", function (e) {
          e.preventDefault();

          for(var i = topListNum; i < $("#Topinfo li").length; i++ ){
            $("#Topinfo li").eq(i).css('display','block').css({opacity : 0}).delay(i * 80).animate({opacity : 1}, 160);
        }
        $(".info__moreBtn").hide();
    });

  }



    },

    csvGet:function(csv,addNum){
      setTimeout(function(){
        var request = new XMLHttpRequest();
        request.open("get", csv, true);
        request.onreadystatechange = function() {
        if (request.readyState == 4 && request.status == 200) {
          console.log(request.responseText);

            var k =(/,|\n/g);
            var getArray = request.responseText.split(k)
            console.log(getArray);
            var areaHtml = '';
            console.log(getArray[1].trim());
            if(getArray[1].trim().length > 0){//リンクあり
              console.log( getArray[2] );
              areaHtml += '<li class="info--red"><div class="info__inner"><span class="info__icon">重要</span><span class="info__ttl"><a target="_blank" href="' + getArray[1] + '" class="over blank">' + getArray[0] + '</a><span><p class="info__txt">' + getArray[2] + '</p>' +'</div></li>';
              $("#info .info").prepend(areaHtml);

            }else{//リンクなし
              areaHtml += '<li class="info--red"><div class="info__inner"><span class="info__icon">重要</span><span class="info__ttl" style="border:none;">' + getArray[0] + '</span><p class="info__txt">' + getArray[2] + '</p>' +'</div></li>';
              $("#info .info").prepend(areaHtml);
            }

            // if(addNum == -1) {
            //   $("#info .info li:empty").remove();
            // }
        }
      };
        request.send(null);

      },100* addNum);
    },

  }



  $(function() {
    Common.init();
  })

})(jQuery);
